// extracted by mini-css-extract-plugin
module.exports = {"footer":"_3voSl0","minimal":"_38ZGvo","footer-content":"_3rc_xQ"};